var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaws = function SvgPaws(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167.463,
    height: 282.044,
    "data-name": "Group 248"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paws_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e71019",
    d: "M0 0h167.463v282.044H0z",
    "data-name": "Rectangle 185"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#e71019",
    strokeMiterlimit: 10,
    clipPath: "url(#paws_svg__a)",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.529 37.568a66 66 0 0 0-6.367 6.78c-4.47 5.367-10.264 12.358-6.089 19.49a10.8 10.8 0 0 0 3.176 3.584c3.492 2.369 9.008 2.867 13.083 3.682q7.769 1.549 15.667 2.348c3.769.383 7.173.072 9.707-3.114a13.13 13.13 0 0 0 2.585-7.8c.211-7.024-3.25-12.535-6.693-18.368a47 47 0 0 0-5.786-8.116c-1.945-2.109-4.244-4.584-7.268-4.9a8.88 8.88 0 0 0-5.359 1.48 43 43 0 0 0-6.656 4.934Z",
    "data-name": "Path 950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.239 31.039a10.72 10.72 0 0 0 1.374 5.868 7.08 7.08 0 0 0 10.734 1.115c1.773-1.829 2.387-4.476 2.711-7 .635-4.941.211-10.339-4-13.64a5.56 5.56 0 0 0-3.111-1.328 5.05 5.05 0 0 0-4.054 2.175c-2.538 3.34-3.6 8.576-3.653 12.672Z",
    "data-name": "Path 951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.611 7.485c-1.657 4.095-2.613 12.537 1.133 15.916a5.7 5.7 0 0 0 3.021 1.274 8.86 8.86 0 0 0 6.789-1.611c2.068-1.711 2.829-4.535 3.1-7.2a19.4 19.4 0 0 0-.668-7.947c-.909-2.806-3.059-6.432-6.332-6.624-3.111-.18-5.48 2.847-6.677 5.37q-.196.404-.366.822Z",
    "data-name": "Path 952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.013 14.239a20.45 20.45 0 0 0 .424 7.957 9.84 9.84 0 0 0 2.03 4.211 6.65 6.65 0 0 0 5.688 2.1 6.88 6.88 0 0 0 5.033-3.409c1.393-2.477 1.136-5.506.948-8.34a21 21 0 0 0-1.03-6.408c-1.038-2.621-4.419-5.493-7.425-4.275-3.443 1.391-5.118 4.628-5.668 8.164Z",
    "data-name": "Path 953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.392 42.303a4.8 4.8 0 0 0 1.3 2.114 6.35 6.35 0 0 0 3.666 1.48 7.6 7.6 0 0 0 4.319-.814 9.02 9.02 0 0 0 4.2-6.5c.776-4.437.141-10.269-2.762-13.876-1.164-1.449-3.1-2.644-4.82-1.95a5 5 0 0 0-2.109 2.027 25.2 25.2 0 0 0-3.869 9.984c-.326 2.057-.693 5.191.075 7.535Z",
    "data-name": "Path 954"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m121.807 39.212 3.628-2.962",
    "data-name": "Line 215"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m124.044 40.24 8.463-7.98",
    "data-name": "Line 216"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m126.885 41.328 8.342-8.283",
    "data-name": "Line 217"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m129.303 43.564 4.232-4.655",
    "data-name": "Line 218"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m134.684 37.278 2.359-2.721",
    "data-name": "Line 219"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m131.178 45.923 7.677-8.887",
    "data-name": "Line 220"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m135.107 46.527 5.562-6.952",
    "data-name": "Line 221"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m136.679 50.154 6.045-7.859",
    "data-name": "Line 222"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m144.235 45.137-9.552 12.574",
    "data-name": "Line 223"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m145.384 47.797-4.936 6.577",
    "data-name": "Line 224"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m147.137 51-6.166 8.039",
    "data-name": "Line 225"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m148.407 53.963-6.015 8.373",
    "data-name": "Line 226"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m149.797 58.194-7.826 10.082",
    "data-name": "Line 227"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m108.87 17.691-3.083 3.445",
    "data-name": "Line 228"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m111.41 18.779-5.442 5.804",
    "data-name": "Line 229"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m108.326 25.49 2.721-2.721",
    "data-name": "Line 230"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m108.145 29.116 5.622-5.259",
    "data-name": "Line 231"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m108.87 31.475 4.172-3.628",
    "data-name": "Line 232"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m113.495 31.112-2.857 2.176",
    "data-name": "Line 233"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m126.19 1.278-2.585 4.306",
    "data-name": "Line 234"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m127.233 2.729-3.628 6.392",
    "data-name": "Line 235"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m129.183 5.041-2.675 3.854",
    "data-name": "Line 236"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m130.452 6.492-1.179 2.176",
    "data-name": "Line 237"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m128.049 9.984-1.315 1.814",
    "data-name": "Line 238"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m131.404 9.666-4.08 5.349",
    "data-name": "Line 239"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m131.223 14.517-4.126 4.172",
    "data-name": "Line 240"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m145.141 6.628-3.021 3.749",
    "data-name": "Line 241"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m146.714 7.475-4.594 6.287",
    "data-name": "Line 242"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m149.374 8.805-4.111 4.715",
    "data-name": "Line 243"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m149.615 13.157-4.835 5.077",
    "data-name": "Line 244"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m149.979 16.422-3.266 2.901",
    "data-name": "Line 245"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m150.099 19.807-3.266 3.021",
    "data-name": "Line 246"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m161.222 23.797-2.78 3.386",
    "data-name": "Line 247"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m162.673 25.369-3.869 4.835",
    "data-name": "Line 248"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m164.124 27.061-4.594 6.045",
    "data-name": "Line 249"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m165.454 29.238-5.2 6.649",
    "data-name": "Line 250"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m165.637 33.528-1.816 1.816",
    "data-name": "Line 251"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m165.333 37.218-3.869 3.507",
    "data-name": "Line 252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.42 180.6a66 66 0 0 0-6.367 6.78c-4.47 5.367-10.264 12.358-6.084 19.49a10.8 10.8 0 0 0 3.176 3.584c3.492 2.369 9.008 2.867 13.083 3.682q7.769 1.549 15.667 2.348c3.769.383 7.173.072 9.707-3.114a13.13 13.13 0 0 0 2.585-7.8c.211-7.024-3.25-12.535-6.693-18.368a47 47 0 0 0-5.786-8.116c-1.945-2.109-4.244-4.584-7.268-4.9a8.88 8.88 0 0 0-5.359 1.48 43 43 0 0 0-6.661 4.934Z",
    "data-name": "Path 955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.131 174.069a10.72 10.72 0 0 0 1.372 5.868 7.08 7.08 0 0 0 10.734 1.115c1.773-1.829 2.387-4.476 2.711-7 .635-4.941.211-10.339-4-13.64a5.56 5.56 0 0 0-3.111-1.328 5.05 5.05 0 0 0-4.052 2.177c-2.538 3.34-3.6 8.576-3.653 12.672Z",
    "data-name": "Path 956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.506 150.516c-1.655 4.093-2.613 12.535 1.133 15.914a5.7 5.7 0 0 0 3.021 1.274 8.86 8.86 0 0 0 6.793-1.611c2.068-1.711 2.829-4.535 3.1-7.2a19.4 19.4 0 0 0-.668-7.947c-.912-2.806-3.063-6.436-6.338-6.624-3.111-.18-5.48 2.847-6.677 5.37q-.195.404-.364.824Z",
    "data-name": "Path 957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.905 157.271a20.45 20.45 0 0 0 .424 7.957 9.84 9.84 0 0 0 2.03 4.211 6.65 6.65 0 0 0 5.688 2.1 6.88 6.88 0 0 0 5.033-3.409c1.393-2.477 1.136-5.506.948-8.34a21 21 0 0 0-1.03-6.408c-1.038-2.621-4.419-5.493-7.425-4.275-3.444 1.391-5.119 4.628-5.668 8.164Z",
    "data-name": "Path 958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.286 185.335a4.8 4.8 0 0 0 1.3 2.114 6.35 6.35 0 0 0 3.666 1.48 7.6 7.6 0 0 0 4.319-.814 9.02 9.02 0 0 0 4.2-6.5c.776-4.437.141-10.269-2.762-13.876-1.164-1.449-3.1-2.644-4.82-1.95a5 5 0 0 0-2.109 2.027 25.2 25.2 0 0 0-3.869 9.984c-.326 2.055-.693 5.189.075 7.535Z",
    "data-name": "Path 959"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m104.699 182.243 3.628-2.962",
    "data-name": "Line 253"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m106.936 183.271 8.463-7.98",
    "data-name": "Line 254"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m109.777 184.359 8.342-8.283",
    "data-name": "Line 255"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m112.195 186.595 4.232-4.655",
    "data-name": "Line 256"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m117.575 180.309 2.359-2.721",
    "data-name": "Line 257"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m114.069 188.954 7.677-8.887",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m117.999 189.558 5.562-6.952",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m119.57 193.185 6.045-7.859",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m127.127 188.168-9.552 12.574",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m128.276 190.828-4.936 6.577",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m130.029 194.031-6.166 8.039",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m131.299 196.994-6.015 8.373",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m132.689 201.225-7.826 10.082",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m91.762 160.722-3.083 3.445",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m94.302 161.81-5.442 5.804",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m91.218 168.521 2.721-2.721",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m91.037 172.147 5.622-5.259",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m91.762 174.505 4.172-3.628",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m96.387 174.143-2.857 2.176",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m109.082 144.309-2.585 4.306",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m110.125 145.76-3.628 6.392",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m112.075 148.072-2.675 3.854",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m113.344 149.523-1.179 2.176",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m110.94 153.015-1.315 1.814",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m114.296 152.697-4.08 5.349",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m114.114 157.548-4.126 4.172",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m128.033 149.659-3.021 3.749",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m129.606 150.506-4.594 6.287",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m132.266 151.836-4.111 4.715",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m132.507 156.188-4.835 5.077",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m132.871 159.453-3.266 2.901",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m132.991 162.838-3.266 3.021",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m144.114 166.828-2.78 3.386",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m145.565 168.4-3.869 4.835",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m147.016 170.092-4.594 6.045",
    "data-name": "Line 287"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m148.346 172.269-5.2 6.649",
    "data-name": "Line 288"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m148.529 176.559-1.816 1.816",
    "data-name": "Line 289"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m148.225 180.248-3.869 3.507",
    "data-name": "Line 290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.464 100.982a66 66 0 0 1 6.367 6.78c4.47 5.367 10.264 12.358 6.089 19.49a10.8 10.8 0 0 1-3.176 3.589c-3.492 2.369-9.008 2.867-13.083 3.682q-7.769 1.549-15.667 2.348c-3.769.383-7.173.072-9.707-3.114a13.13 13.13 0 0 1-2.585-7.8c-.211-7.024 3.25-12.535 6.693-18.368a47 47 0 0 1 5.786-8.116c1.945-2.109 4.244-4.584 7.268-4.9a8.88 8.88 0 0 1 5.359 1.48 43 43 0 0 1 6.656 4.929Z",
    "data-name": "Path 960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.752 94.451a10.72 10.72 0 0 1-1.372 5.868 7.08 7.08 0 0 1-10.734 1.113c-1.773-1.829-2.387-4.476-2.711-7-.635-4.941-.211-10.339 4-13.64a5.56 5.56 0 0 1 3.111-1.328 5.05 5.05 0 0 1 4.057 2.177c2.538 3.34 3.6 8.576 3.653 12.672Z",
    "data-name": "Path 961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.381 70.898c1.655 4.093 2.613 12.535-1.133 15.914a5.7 5.7 0 0 1-3.021 1.274 8.86 8.86 0 0 1-6.793-1.611c-2.068-1.711-2.829-4.535-3.1-7.2a19.4 19.4 0 0 1 .668-7.947c.912-2.806 3.063-6.436 6.338-6.624 3.111-.18 5.48 2.847 6.677 5.37q.189.404.364.824Z",
    "data-name": "Path 962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.98 77.653a20.45 20.45 0 0 1-.424 7.957 9.84 9.84 0 0 1-2.03 4.211 6.65 6.65 0 0 1-5.688 2.1 6.88 6.88 0 0 1-5.029-3.413c-1.393-2.477-1.136-5.506-.948-8.34a21 21 0 0 1 1.03-6.408c1.034-2.62 4.418-5.496 7.418-4.275 3.446 1.395 5.121 4.632 5.671 8.168Z",
    "data-name": "Path 963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6 105.714a4.8 4.8 0 0 1-1.3 2.114 6.35 6.35 0 0 1-3.667 1.477 7.6 7.6 0 0 1-4.319-.814 9.02 9.02 0 0 1-4.2-6.5c-.776-4.437-.141-10.269 2.762-13.876 1.164-1.449 3.1-2.644 4.82-1.95a5 5 0 0 1 2.117 2.029 25.2 25.2 0 0 1 3.869 9.984c.318 2.058.686 5.192-.082 7.536Z",
    "data-name": "Path 964"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m65.185 102.625-3.628-2.962",
    "data-name": "Line 291"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m62.948 103.653-8.463-7.98",
    "data-name": "Line 292"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m60.107 104.741-8.342-8.283",
    "data-name": "Line 293"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m57.689 106.977-4.232-4.655",
    "data-name": "Line 294"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M52.309 100.691 49.95 97.97",
    "data-name": "Line 295"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m55.815 109.335-7.677-8.887",
    "data-name": "Line 296"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m51.885 109.939-5.562-6.952",
    "data-name": "Line 297"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m50.313 113.567-6.045-7.859",
    "data-name": "Line 298"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m42.757 108.549 9.552 12.574",
    "data-name": "Line 299"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m41.608 111.209 4.936 6.577",
    "data-name": "Line 300"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m39.855 114.413 6.166 8.039",
    "data-name": "Line 301"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m38.586 117.375 6.015 8.373",
    "data-name": "Line 302"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m37.195 121.607 7.826 10.082",
    "data-name": "Line 303"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m78.122 81.104 3.083 3.445",
    "data-name": "Line 304"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m75.583 82.192 5.442 5.804",
    "data-name": "Line 305"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m78.666 88.902-2.721-2.721",
    "data-name": "Line 306"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m78.848 92.529-5.622-5.259",
    "data-name": "Line 307"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m78.121 94.887-4.172-3.628",
    "data-name": "Line 308"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m73.497 94.524 2.857 2.176",
    "data-name": "Line 309"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m60.802 64.691 2.585 4.306",
    "data-name": "Line 310"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m59.759 66.142 3.628 6.392",
    "data-name": "Line 311"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m57.81 68.454 2.675 3.854",
    "data-name": "Line 312"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m56.54 69.905 1.179 2.176",
    "data-name": "Line 313"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m58.943 73.396 1.315 1.814",
    "data-name": "Line 314"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m55.588 73.079 4.08 5.349",
    "data-name": "Line 315"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m55.77 77.93 4.126 4.172",
    "data-name": "Line 316"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m41.85 70.041 3.021 3.749",
    "data-name": "Line 317"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m40.279 70.887 4.594 6.287",
    "data-name": "Line 318"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m37.619 72.217 4.111 4.715",
    "data-name": "Line 319"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m37.377 76.57 4.835 5.077",
    "data-name": "Line 320"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m37.014 79.834 3.266 2.901",
    "data-name": "Line 321"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m36.893 83.22 3.266 3.021",
    "data-name": "Line 322"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m25.77 87.21 2.78 3.386",
    "data-name": "Line 323"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m24.319 88.781 3.869 4.835",
    "data-name": "Line 324"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m22.868 90.474 4.594 6.045",
    "data-name": "Line 325"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m21.538 92.65 5.2 6.649",
    "data-name": "Line 326"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m21.355 96.94 1.816 1.816",
    "data-name": "Line 327"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m21.659 100.63 3.869 3.507",
    "data-name": "Line 328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.935 244.749a66 66 0 0 1 6.367 6.78c4.47 5.367 10.264 12.358 6.089 19.49a10.8 10.8 0 0 1-3.176 3.584c-3.492 2.369-9.008 2.867-13.083 3.682q-7.769 1.549-15.667 2.348c-3.769.383-7.173.072-9.707-3.114a13.13 13.13 0 0 1-2.585-7.8c-.211-7.024 3.25-12.535 6.693-18.367a47 47 0 0 1 5.786-8.116c1.945-2.109 4.244-4.584 7.268-4.9a8.88 8.88 0 0 1 5.359 1.48 43 43 0 0 1 6.656 4.933Z",
    "data-name": "Path 965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.223 238.215a10.72 10.72 0 0 1-1.372 5.868 7.08 7.08 0 0 1-10.734 1.115c-1.773-1.829-2.387-4.476-2.711-7-.635-4.941-.211-10.339 4-13.64a5.56 5.56 0 0 1 3.111-1.328 5.05 5.05 0 0 1 4.049 2.179c2.538 3.34 3.6 8.576 3.653 12.671Z",
    "data-name": "Path 966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.852 214.663c1.652 4.093 2.613 12.535-1.133 15.914a5.7 5.7 0 0 1-3.024 1.274 8.85 8.85 0 0 1-6.791-1.611c-2.068-1.711-2.829-4.535-3.1-7.2a19.3 19.3 0 0 1 .668-7.947c.91-2.806 3.063-6.436 6.338-6.624 3.111-.18 5.478 2.847 6.675 5.37.133.269.251.544.367.824Z",
    "data-name": "Path 967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.451 221.418a20.45 20.45 0 0 1-.424 7.957 9.84 9.84 0 0 1-2.03 4.211 6.65 6.65 0 0 1-5.688 2.1 6.88 6.88 0 0 1-5.034-3.413c-1.394-2.477-1.135-5.506-.948-8.34a21 21 0 0 1 1.03-6.408c1.038-2.621 4.419-5.493 7.425-4.275 3.444 1.395 5.119 4.632 5.669 8.168Z",
    "data-name": "Path 968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.069 249.479a4.76 4.76 0 0 1-1.3 2.115 6.35 6.35 0 0 1-3.666 1.48 7.6 7.6 0 0 1-4.318-.815 9.04 9.04 0 0 1-4.2-6.5c-.77-4.438-.138-10.27 2.768-13.877 1.161-1.449 3.093-2.644 4.817-1.95a5.03 5.03 0 0 1 2.115 2.027 25.3 25.3 0 0 1 3.869 9.984c.318 2.058.683 5.192-.085 7.536Z",
    "data-name": "Path 969"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m45.656 246.389-3.628-2.962",
    "data-name": "Line 329"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m43.419 247.417-8.463-7.98",
    "data-name": "Line 330"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m40.578 248.505-8.342-8.283",
    "data-name": "Line 331"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m38.16 250.742-4.232-4.655",
    "data-name": "Line 332"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m32.78 244.455-2.359-2.721",
    "data-name": "Line 333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m36.286 253.1-7.677-8.887",
    "data-name": "Line 334"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m32.356 253.704-5.562-6.952",
    "data-name": "Line 335"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m30.784 257.331-6.045-7.859",
    "data-name": "Line 336"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m23.228 252.314 9.552 12.574",
    "data-name": "Line 337"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m22.079 254.974 4.936 6.577",
    "data-name": "Line 338"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m20.326 258.178 6.166 8.039",
    "data-name": "Line 339"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m19.057 261.14 6.015 8.373",
    "data-name": "Line 340"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m17.666 265.372 7.826 10.082",
    "data-name": "Line 341"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m58.593 224.868 3.083 3.445",
    "data-name": "Line 342"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m56.054 225.956 5.442 5.804",
    "data-name": "Line 343"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m59.137 232.667-2.721-2.721",
    "data-name": "Line 344"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m59.319 236.294-5.622-5.259",
    "data-name": "Line 345"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m58.592 238.652-4.172-3.628",
    "data-name": "Line 346"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m53.968 238.289 2.857 2.176",
    "data-name": "Line 347"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m41.273 208.455 2.585 4.306",
    "data-name": "Line 348"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m40.23 209.906 3.628 6.392",
    "data-name": "Line 349"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m38.28 212.219 2.675 3.854",
    "data-name": "Line 350"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m37.011 213.669 1.179 2.176",
    "data-name": "Line 351"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m39.414 217.161 1.315 1.814",
    "data-name": "Line 352"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m36.059 216.843 4.08 5.349",
    "data-name": "Line 353"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m36.24 221.695 4.126 4.172",
    "data-name": "Line 354"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m22.321 213.805 3.021 3.749",
    "data-name": "Line 355"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m20.749 214.652 4.594 6.287",
    "data-name": "Line 356"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m18.089 215.982 4.111 4.715",
    "data-name": "Line 357"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m17.847 220.334 4.835 5.077",
    "data-name": "Line 358"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m17.485 223.599 3.266 2.901",
    "data-name": "Line 359"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m17.364 226.984 3.266 3.021",
    "data-name": "Line 360"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m6.241 230.974 2.78 3.386",
    "data-name": "Line 361"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m4.79 232.546 3.869 4.835",
    "data-name": "Line 362"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m3.339 234.239 4.594 6.045",
    "data-name": "Line 363"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m2.009 236.415 5.2 6.649",
    "data-name": "Line 364"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m1.825 240.705 1.816 1.816",
    "data-name": "Line 365"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m2.13 244.395 3.869 3.507",
    "data-name": "Line 366"
  }))));
};
export default SvgPaws;